import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import {
  CorpTypeList2,
  FormKbn,
  Prefectures,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import TkStepper from "../../components/atoms/TkStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkGetCode } from "../../utils/TkGetCode";
import { IAPI_COM005_Request, IAPI_CON002_Request } from "../../type/apiType";
import { httpAPI_COM005, httpAPI_CON002, httpAPI_COM009 } from "./api/request";
import {
  schema,
  stepperData,
  fakeTableList,
  headTitleList,
  headTitleList2,
} from "./parts";
import "./_style.scss";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRC070002 申請情報詳細（新規契約）
 * @returns JSX.Element
 */
const SCRC070002 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [bodyListData, setBodyListData] = useState([]);
  const [bodyList, setBodyList] = useState([]);
  const resData = useRef<any>();
  const timerId = useRef<NodeJS.Timeout | null>(null);

  const handleInfoBtnClick = (item: any) => {
    setBusinessState({
      ...businessState,
      job_15: {
        facilityList: [
          {
            facilityNo: item.facilityNo,
            facilityName: item.facilityName,
            facilityKind: item.facilityKind,
          },
        ],
      },
    });
    navigate("/SCRC070003");
  };

  useEffect(() => {
    handleInit();
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    const applyIdData: IAPI_CON002_Request = {
      applyId: businessState.job_01?.applyId!,
    };

    // 共済契約申請書参照API呼び出し
    try {
      const res = (await httpAPI_CON002({
        ...applyIdData,
      })) as { [key: string]: any };

      let resArr = stateFakeTableList.current;
      if (res.resultCd === "I0000") {
        resData.current = res;

        // 初期表示
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          targetObj && (targetObj.setDefaultValue = res[i]);
          targetObj && (targetObj.text = res[i]);
        }

        const showLine = isStatusAfterApproval(res.latestApplyStatus);
        const bodyData: any = res.formList
          ?.filter((item: any) => item.formClass === "RPT0101021")
          .map(() => [
            {
              children: (
                <TkDownloadLink
                  base64filedata=""
                  dataname="重要事項確認書"
                  linkDisabled
                />
              ),
            },
            {
              children: showLine && res.symbolNo,
            },
            {
              children: showLine && res.decisionDate,
            },
          ]);

        setBodyList(bodyData);

        res.formList.forEach((item2: any) => {
          if (item2.formClass === "1") {
            let certificate = resArr.find(
              (item3) => item3.keyword === "certificate"
            )!;
            certificate.showLine = true;
            certificate.downloadBase64 = true;
            certificate.base64filedata = item2.fileBase64;
          }

          if (item2.formClass === "2") {
            let employmentRegulations = resArr.find(
              (item3) => item3.keyword === "employmentRegulations"
            )!;
            employmentRegulations.showLine = true;
            employmentRegulations.downloadBase64 = true;
            employmentRegulations.base64filedata = item2.fileBase64;
          }

          if (item2.formClass === "3") {
            let salaryRegulations = resArr.find(
              (item3) => item3.keyword === "salaryRegulations"
            )!;
            salaryRegulations.showLine = true;
            salaryRegulations.downloadBase64 = true;
            salaryRegulations.base64filedata = item2.fileBase64;
          }
        });
        resArr.find((item) => item.keyword === "businessOwnerClass")!.text =
          TkGetCode(CorpTypeList2, res.businessOwnerClass);

        resArr.find((item) => item.keyword === "address")!.text =
          (res.prefectureCd ? TkGetCode(Prefectures, res.prefectureCd) : "") +
          (res.addressCity ?? "") +
          (res.addressOthers ?? "");

        resArr.find((item) => item.keyword === "typeOffacilityOperated")!.text =
          res.mainFacilityKinds;

        resArr.find(
          (item) => item.keyword === "pastContractCancelDate"
        )!.showLine = res.pastContractFlg === YesOrNoFlug["有"];

        const listData = res.facilityList?.map((item: any) => [
          {
            children: item.facilityKind,
          },
          {
            children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
          },
          {
            children: (
              <TkButton onClick={() => handleInfoBtnClick(item)}>
                職員情報参照
              </TkButton>
            ),
          },
        ]);
        setBodyListData(listData);
        handleDownloadData();

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
      setStateTableList(resArr);
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDownloadData = async () => {
    try {
      // 帳票作成状況取得APIを呼び出す。
      const res = await httpAPI_COM009({
        applyId: businessState.job_01?.applyId,
        FormList: [{ formClass: "RPT0101021", formKbn: FormKbn["申請"] }],
      });

      if (res.resultCd === "I0000") {
        let requestId = "";
        res.FormList?.forEach((form) => {
          if (form.formOutputStatus === "3") {
            requestId = form.requestId!;
            handleFormDownload(requestId);
          }
        });

        if (!requestId) {
          timerId.current = setTimeout(() => {
            handleDownloadData();
          }, 10000);
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleFormDownload = async (requestId: string) => {
    let reqData: IAPI_COM005_Request = {
      formList: [
        {
          requestId: requestId,
        },
      ],
    };

    // 帳票ダウンロードAPI呼び出し
    try {
      const res = await httpAPI_COM005({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        const showLine = isStatusAfterApproval(
          resData.current?.latestApplyStatus
        );
        const bodyData: any = [
          [
            {
              children: (
                <TkDownloadLink
                  base64filedata={res.formList?.[0].fileBase64 || ""}
                  dataname="重要事項確認書"
                  downloadBase64={true}
                />
              ),
            },
            {
              children: showLine && resData.current?.symbolNo,
            },
            {
              children: showLine && resData.current?.decisionDate,
            },
          ],
        ];

        setBodyList(bodyData);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC070002PageForTest">
      <TkStepper steps={stepperData} activeStep={0} />

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
      />

      <Box className="info">施設情報</Box>
      <TkTable headList={headTitleList} bodyList={bodyListData} />

      <TkTableWithNoLine headList={headTitleList2} bodyList={bodyList} />

      <Box className="backbtn">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC070002;
